import React from 'react';
import './Footnote.css';

const Footnote = () => (
  <footer className="footnote">
    <p>&copy; 2026 Taïga Gonçalves/Nakajima. All rights reserved.</p>
    <p>Last updated: July 03, 2026</p>
  </footer>
);

export default Footnote;
